import { render, staticRenderFns } from "./BuroPicker.vue?vue&type=template&id=bbddd4ba"
import script from "./BuroPicker.vue?vue&type=script&lang=ts"
export * from "./BuroPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports